
export default class Protocol {
  constructor() {
    this.hash = null;
    this.status = 1;
    this.saved_values = null;
    this.version = null;
    this.theme = null;
    this.dark = false;
    this.logo = null;
  }
}
